import React from "react"
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import CCOContainer from "../../fundamentals/CCOContainer";
import {styled} from '@mui/material'
import CCOHeadline from "../../fundamentals/CCOHeadline";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import NextLink from "next/link";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {CmCollectionType, CmTeasableType} from "../../types";
import {dataLayerTopicNavigation} from "tracking/events/navigation";


export interface Props {
    cmCollection: CmCollectionType
}

const RectangularChip = styled(Chip,
                               {shouldForwardProp: (prop) => prop !== "current"})<{
    current?: boolean
}>
(({theme, current}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 8,
    backgroundColor: current ? theme.palette.primary.main : undefined,
    '& .MuiChip-label': {
        fontSize: 15,
        textAlign: 'left',
        color: current ? theme.palette.primary.contrastText : undefined,
    },
    '& .MuiChip-icon': {
        fontSize: 15,
        textAlign: 'left',
        color: current ? theme.palette.primary.contrastText : theme.palette.primary.main,
    },
    '&:hover': {
        '& .MuiChip-icon': {
            color: theme.palette.primary.contrastText,
        },
        cursor: 'pointer',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '@keyframes bounce': {
            '0%': {
                transform: 'translateX(0)',
            },
            '50%': {
                transform: 'translateX(8px)',
            },
            '100%': {
                transform: 'translateX(0)',
            },
        },
    }
}));

function renderItem(index: number, item: CmTeasableType, active: boolean) {
    return <Grid key={index} size={{sm: 12, md: 4}}>
        <NextLink shallow={false} href={item.selfUrl!} prefetch={false}
                  onClick={() => dataLayerTopicNavigation((item as any)?.teaserTitle)}>
            <RectangularChip current={active} sx={{
                width: '100%',
                minHeight: 50,
                padding: 3,
            }} label={` ${item.teaserTitle}`} icon={<ArrowForwardIosIcon/>}/>
        </NextLink>
    </Grid>
}

function renderTags(items: any) {
    let path = '';
    if (typeof window !== "undefined") {
        path = window?.location?.pathname;
    }
    return items?.map((item: CmTeasableType, index: number) => {
                          const active = path === item.selfUrl;
                          return renderItem(index, item, active)
                      }
    )
}

function C069ContentTag(props: Props) {
    const items = props.cmCollection.items;
    return items ? <CCOComponentWrapper>
        <CCOHeadline headline={props.cmCollection.teaserTitle}
                     metadataId={props.cmCollection.id}
                     propertyName='properties.teaserTitle'
                     type={"componenthead"}
        />
        <CCOContainer width={"large"} id={props.cmCollection.id}>
            <Grid spacing={3} columnSpacing={3} container>
                {
                    renderTags(items)
                }
            </Grid>
        </CCOContainer>
    </CCOComponentWrapper> : null;
}

export default C069ContentTag;